import * as React from 'react';
import { useConfiguratorContext } from '@grandvisionhq/configurator';
import { ReviewStep } from './ReviewStep.js';

const ReviewStepContainer = ()=>{
    const { goToNextStep  } = useConfiguratorContext();
    return /*#__PURE__*/ React.createElement(ReviewStep, {
        onSubmit: goToNextStep
    });
};

export { ReviewStepContainer };
//# sourceMappingURL=ReviewStepContainer.js.map
